<template>
  <div id="Formato3">
<!-- SELECTTTTT-->
    <div  class="seleccion">
      <select v-on:change="valorDeLaPestania($event)" class="col-12">
        <option
          v-for="(seccion, valor) in Grupo.Secciones"
          :key="valor"
          :value="seccion.SeccionesDeMicrositioId+'°'+Grupo.grupo"
          :name="Grupo.grupo"
          class="opcion"><font class="opcion">{{ seccion.NombreDeLaSeccion }}</font></option
        >
      </select>
    </div>
<!-- FIN SELECTTTTT-->

<div :id="Grupo.grupo">

    <table v-for="(fila,index) in Grupo.Secciones" :key="fila.SeccionesDeMicrositioId" :id="'pestana' + fila.SeccionesDeMicrositioId" v-show="index==0"  class="table table-striped table-hover table-bordered mt-4">
      <thead class="thead-dark">
        <tr>
          <th></th>
          <th
            class="titulo text-center"
            v-for="titulo in fila.Titulo.split('|')"
            :key="titulo.id"
          >
            {{ titulo }}
          </th>
        </tr>
      </thead>
      <tbody v-for="mes in seOrdenPorMeses(fila.ordenarPorMes)" :key="mes.numero">
        <tr v-if="filtrarPorMes(mes.numero, fila.ordenarPorMes, fila.ContenidoDeMicrositio).length != 0 && fila.ordenarPorMes">
          <td :colspan="tituloSeccion.split('|').length + 1" class="separador">
            <center>{{ mes.nombre }}</center>
          </td>
        </tr>
        <tr
          v-for="(data, index) in filtrarPorMes(mes.numero, ordenarPorMes, fila.ContenidoDeMicrositio)"
          :key="index"
        >
          <td class="text-center">{{ index + 1 }}</td>
          <th
            class="texto"
            v-for="textoColumna in data.TextoDelContenido.split('|')"
            :key="textoColumna.index"
          >
            {{ textoColumna }}
          </th>
          <th
            class="w-10 text-center vinculo texto"
            v-for="elemento in data.ArchivosDeContenidoMicrositios"
            :key="elemento.index"
          >
  

          
  
 

 <router-link v-if="elemento.AbrirEnVisor==false && elemento.RutaDeArchivoCarpeta != null && elemento.RutaDeArchivoCarpeta.includes('Micrositio')" :to="elemento.RutaDeArchivoCarpeta" >{{ elemento.TextoDescripcion }}</router-link>
           
            <a
              v-else-if="elemento.AbrirEnVisor == true && elemento.RutaDeArchivoCarpeta!=null"
              v-on:click="AbreElVisor(elemento.RutaDeArchivoCarpeta)"
              >{{ elemento.TextoDescripcion }}</a
            >
            <a v-else-if="elemento.AbrirEnVisor==false && elemento.RutaDeArchivoCarpeta != null && elemento.RutaDeArchivoCarpeta.includes('http') && !elemento.RutaDeArchivoCarpeta.includes('themisfstest\\Files')" target="_blank" :href="elemento.RutaDeArchivoCarpeta">  
              {{ elemento.TextoDescripcion }}</a>

              <a
              v-else-if="elemento.AbrirEnVisor == false && elemento.RutaDeArchivoCarpeta!=null"
              v-on:click="AbrirArchivo(elemento.RutaDeArchivoCarpeta, '_self')"
              >{{ elemento.TextoDescripcion }} </a
            >
            <a v-else-if="elemento.RutaDeArchivoCarpeta==null">
              {{ elemento.TextoDescripcion }}</a>
          </th>
        </tr>
      </tbody>  
    </table> 
    </div>
  </div>
</template>
<script>
import comun from "@/../static/js/comun";
export default {
  props: {
    contenidos: Array,
    tituloSeccion: String,
    idTabla: Number,
    seccionesCombo: Array,
    ordenarPorMes: Boolean,
    Seccion:Object,
    Grupo:Object
  },
  data() {
    return {
      meses: [
        { nombre: "ENERO", numero: "01" },
        { nombre: "FEBRERO", numero: "02" },
        { nombre: "MARZO", numero: "03" },
        { nombre: "ABRIL", numero: "04" },
        { nombre: "MAYO", numero: "05" },
        { nombre: "JUNIO", numero: "06" },
        { nombre: "JULIO", numero: "07" },
        { nombre: "AGOSTO", numero: "08" },
        { nombre: "SEPTIEMBRE", numero: "09" },
        { nombre: "OCTUBRE", numero: "10" },
        { nombre: "NOBIEMBRE", numero: "11" },
        { nombre: "DICIEMBRE", numero: "12" }
      ]
    };
  },
  methods: {
    seOrdenPorMeses: function(conMeses) {
      var mesesRequeridos;
      let soloUnaVez = [{ nombre: "Unico", numero: "01" }];
      if (conMeses) mesesRequeridos = this.meses;
      else mesesRequeridos = soloUnaVez;
      return mesesRequeridos;
    },
    valorDeLaPestania: function(valor) { 
      let grupo = valor.target.value.split('°').pop();
      let opcion = valor.target.value.split('°').shift();
      let otrosElementos = $('#'+grupo+' > table')
      var elemento = "pestana" + opcion;

for(let i=0;i<otrosElementos.length;i++){
  if(elemento != otrosElementos[i].id) $('#'+otrosElementos[i].id).hide()
}
      if ($("#" + elemento).is(":visible")) {
        $("#" + elemento).hide();
      } else {
        $("#" + elemento).show();
      }
    },
    AbreElVisor: function(vinculo) {
     // console.log("abrirel visor:::",vinculo)
      this.$store.dispatch("A_PaginaOficial_EstableceLaRutaParaElVisor",vinculo);
    },
    AbrirArchivo: function(vinculo, forma) {
      comun.DescargarDocumentoPDF(vinculo);
      //console.log("abrir archivo " + vinculo);
     // window.open(vinculo, forma);
    },
    filtrarPorMes: function(mes, porMes,contenidosSeccion) {
      var filtro;
      if (porMes)
        filtro = contenidosSeccion.filter(
          porMes => porMes.FechaDePublicacion.split("-")[1] == mes
        );
      else filtro = contenidosSeccion;
     
      return filtro;
    }
  },
 mounted() {
  // console.log("grupo de Secciones:::",this.Grupo)
 },
};
</script>
<style scoped>
.separador{
  font-family: "AntenaBeta";
  font-size: 1.5em;
  color: #454547;
  background-color:rgba(135, 141, 146, 0.2) ;
}
.opcion {
  font-family: "AntenaBeta";
}

.seleccion {
  appearance: none;

  margin-top: 2em;
  position: relative;
}

.seleccion select {
  display: inline-block;
  width: 100%;
  cursor: pointer;
  padding: 7px 10px;
  height: 42px;
  outline: 0;
  border: 0;
  border-radius: 0;
  background: #f0f0f0;
  color: #7b7b7b;
  font-size: 1.5em;
  color: #999;
  font-family: "AntenaBeta";
  border: 2px solid rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  position: relative;
  transition: all 0.25s ease;
}

.caja-select {
  margin-top: 2em;
  background-color: black;
  color: white;
  align-content: center;
  font-size: 1.5em;
}
.titulo {
  font-family: "AntenaBeta";
  font-size: 1.6em;
}
#Formato3 .titulo:last-child {
  text-align: center;
}

.vinculo a {
  color: black;
  font-family: "Myriad";
  font-size: 1em;
}
.texto {
  font-family: "Myriad";
  font-size: 1.2em;
}
</style>



// WEBPACK FOOTER //
// src/components/Micrositios/Formatos/Pestanas.vue